import { MenuBlock, MenuRowBreakBlock } from 'state/PublicWebApi/Settings'

const isMenuRowBreakBlock = (
  menuBlock: MenuBlock
): menuBlock is MenuRowBreakBlock => {
  return menuBlock.blockType === 'RowBreakBlock'
}

export const filterOutDoubleRowBreakBlocks = (
  menuElements: MenuBlock[]
): MenuBlock[] => {
  return menuElements?.filter((menuBlock, index) => {
    return !(
      isMenuRowBreakBlock(menuBlock) &&
      isMenuRowBreakBlock(menuElements[index - 1])
    )
  })
}
